import { AllSchedulingMethods } from 'constants/meetings'
import { useGetUserSettingsQuery, usePatchUserSettingsMutation } from 'features/availability'

export const useMeetingsPagePersistentSettings = () => {
  const { data: userSettings } = useGetUserSettingsQuery()
  const [updateUserSettings] = usePatchUserSettingsMutation()

  const meetingsPageSettings = userSettings?.meetingsPageSettings || {}
  const showBuffers = meetingsPageSettings.showBuffers ?? true
  const schedulingMethods = meetingsPageSettings.schedulingMethods?.length > 0
    ? meetingsPageSettings.schedulingMethods
    : AllSchedulingMethods

  const handleBuffersToggle = (newShowBuffers) => {
    updateUserSettings({
      user_settings: {
        meetingsPageSettings: {
          showBuffers: newShowBuffers,
          schedulingMethods,
        },
      },
    })
  }

  const handleSchedulingMethodChange = (newMethods) => {
    updateUserSettings({
      user_settings: {
        meetingsPageSettings: {
          schedulingMethods: newMethods,
          showBuffers,
        },
      },
    })
  }

  return {
    showBuffers,
    schedulingMethods,
    handleBuffersToggle,
    handleSchedulingMethodChange,
  }
}
